<template>
  <div class="app-root">
    <router-view />
    <transition name="logo-intro">
      <div v-if="showIntro" class="logo-intro-overlay">
        <iframe
          ref="introFrame"
          src="/logo/index.html?mode=intro"
          title="Công ty TNHH NWM Việt Nam"
        />
      </div>
    </transition>
    <div
      v-if="!showIntro && pendingApiRequests > 0"
      class="api-loading-overlay"
      role="status"
      aria-label="Đang tải dữ liệu"
    >
      <iframe
        src="/logo/index.html?mode=loading"
        title="Đang tải"
        aria-hidden="true"
        tabindex="-1"
      />
    </div>
  </div>
</template>

<script>
import { apiLoading } from "./utils/apiLoading";
import { clearAuth } from "./utils/auth";

export default {
  name: "AppRoot",
  data: function data() {
    return {
      showIntro: this.$route.name === "home",
      pendingApiRequests: 0
    };
  },
  created: function created() {
    apiLoading.$on("start", this.startApiLoading);
    apiLoading.$on("finish", this.finishApiLoading);
    apiLoading.$on("unauthorized", this.handleUnauthorized);
  },
  mounted: function mounted() {
    window.addEventListener("message", this.handleIntroMessage);
  },
  beforeDestroy: function beforeDestroy() {
    apiLoading.$off("start", this.startApiLoading);
    apiLoading.$off("finish", this.finishApiLoading);
    apiLoading.$off("unauthorized", this.handleUnauthorized);
    window.removeEventListener("message", this.handleIntroMessage);
  },
  methods: {
    startApiLoading: function startApiLoading() {
      this.pendingApiRequests += 1;
    },
    finishApiLoading: function finishApiLoading() {
      this.pendingApiRequests = Math.max(0, this.pendingApiRequests - 1);
    },
    handleUnauthorized: function handleUnauthorized() {
      const isProtectedRoute = this.$route.matched.some(function match(record) {
        return record.meta.requiresAuth;
      });

      if (isProtectedRoute) {
        clearAuth();
        this.$router.replace({ name: "admin-login" });
      }
    },
    handleIntroMessage: function handleIntroMessage(event) {
      const introFrame = this.$refs.introFrame;

      if (
        event.origin === window.location.origin &&
        introFrame &&
        event.source === introFrame.contentWindow &&
        event.data &&
        event.data.type === "nwm-logo-intro-complete"
      ) {
        this.showIntro = false;
      }
    }
  }
};
</script>

<style>
.app-root {
  min-height: 100vh;
}

.logo-intro-overlay,
.api-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
}

.logo-intro-leave-active {
  transition: opacity 650ms ease;
  pointer-events: none;
}

.logo-intro-leave-active iframe {
  transition: transform 650ms cubic-bezier(0.2, 0.75, 0.25, 1);
}

.logo-intro-leave-to {
  opacity: 0;
}

.logo-intro-leave-to iframe {
  transform: scale(0.97);
}

.logo-intro-overlay iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

.api-loading-overlay {
  z-index: 9998;
  display: grid;
  place-items: center;
  background: rgba(248, 253, 255, 0.82);
  backdrop-filter: blur(3px);
}

.api-loading-overlay iframe {
  width: 152px;
  height: 152px;
  border: 0;
  background: transparent;
}

@media (prefers-reduced-motion: reduce) {
  .logo-intro-leave-active,
  .logo-intro-leave-active iframe {
    transition-duration: 1ms;
  }
}
</style>
